import { Flex, Text, ThemeUIStyleObject } from "theme-ui";

import { BaseProp } from "../@types/base-types";

type ActionDescriptionProps = {
  sx?: ThemeUIStyleObject;
} & BaseProp;

export const ActionDescription: React.FC<ActionDescriptionProps> = ({ sx, children }) => (
  <Flex
    variant="layout.actionDescription"
    sx={{
      ...sx
    }}
  >
    <Text variant="text.regularH3" sx={{ color: "B60", textAlign: "center" }}>
      {children}
    </Text>
  </Flex>
);

export const Amount: React.FC<BaseProp> = ({ children }) => <Text>{children}</Text>;
